export default "__VITE_ASSET__CLPwNiVK__"